import { useTranslations } from 'next-intl';

import clsx from 'clsx';
import { Button } from '@/components/common/Button/Button';
import { ReactNode } from 'react';

interface FilterProps {
  className?: string;
  children: ReactNode;
}

export function FilterCondition({ className, children }: FilterProps) {
  return (
    <div
      className={clsx(
        'flex flex-col bg-neutral-auxiliary-tinge border-thin border-neutral-auxiliary divide-y-thin divide-neutral-auxiliary rounded-medium overflow-hidden',
        className
      )}
    >
      {children}
    </div>
  );
}

interface FilterConditionItemProps {
  label: string;
  value?: string;
  onClickChange: () => void;
}

export function FilterConditionItem({ label, value, onClickChange }: FilterConditionItemProps) {
  const t = useTranslations('common');

  return (
    <div className="flex">
      <div className="bg-neutral-auxiliary-tinge flex items-center justify-center p-3 min-w-fit">
        <span className="text-neutral-secondary text-center font-bold text-x-small w-14">
          {label}
        </span>
      </div>
      <div className="bg-neutral-white flex flex-1 items-center justify-between p-3 gap-4">
        <span
          className={clsx(
            'font-bold text-small',
            !value ? 'text-neutral-tertiary' : 'text-neutral-primary'
          )}
        >
          {value || t('label.notSelected')}
        </span>
        <Button
          className="shrink-0"
          variant="outline"
          colorScheme="emphasis"
          size="small"
          onClick={onClickChange}
        >
          {t('action.change')}
        </Button>
      </div>
    </div>
  );
}
